import * as React from 'react';
import { Check, Copy } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

type ButtonVariant = 'default' | 'outline' | 'ghost' | 'secondary';
type ButtonSize = 'default' | 'sm' | 'icon';

/**
 * Copy-to-clipboard button with brief "Copied" feedback. Used for
 * re-viewable bearer credentials (the `tok_` token value, brief 113)
 * and any other copy-this-string surface. The value is written to the
 * clipboard via `navigator.clipboard` and is never logged.
 */
export function CopyButton({
  value,
  label,
  variant = 'ghost',
  size = 'icon',
  className,
}: {
  value: string;
  label?: string;
  variant?: ButtonVariant;
  size?: ButtonSize;
  className?: string;
}) {
  const [copied, setCopied] = React.useState(false);
  const onCopy = () => {
    void navigator.clipboard?.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 1200);
  };
  return (
    <Button
      type="button"
      variant={variant}
      size={size}
      onClick={onCopy}
      className={cn(className)}
      aria-label={label ?? 'Copy'}
    >
      {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
      {label ? <span className="ml-1">{copied ? 'Copied' : label}</span> : null}
    </Button>
  );
}
